"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const SectionMission = () => {
    const t = useTranslations("SectionMission");
    
    return (
        <section className="py-24 lg:py-36">
            <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 items-center gap-8">
                <div className="order-2 lg:order-1 flex justify-center lg:justify-start">
                    <div className="relative w-full max-w-md aspect-square">
                        <Image 
                            src="/promo_img_1.webp" 
                            alt="Mission Image"
                            fill
                            sizes="(max-width: 768px) 90vw, (max-width: 1200px) 50vw, 33vw"
                            priority
                            className="rounded-lg shadow-lg object-cover animate-fly"
                        />
                    </div>
                </div>
                <div className="order-1 lg:order-2 text-center lg:text-left px-4 lg:px-6">
                    <h2 className="text-3xl font-bold mb-6">{t("title")}</h2>
                    <ul className="space-y-4 text-lg leading-8">
                        {[1, 2, 3, 4, 5].map((num) => (
                            <li key={`mission-${num}`} className="flex items-start">
                                <span className="mr-2 text-primary mt-1">•</span>
                                <span>{t(`mission${num}`)}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default SectionMission;